class Result {
	id?: number;
	firstStageStatus: string;
	firstStagePoints: number;
	firstStageQualified: boolean;

	secondAStageTopic: string;
	secondAOneStagePoints: number;
	secondATwoStagePoints: number;
	secondAStageQualified: boolean;

	secondBOneStagePoints: number;
	secondBTwoStagePoints: number;
	secondBThreeStagePoints: number;
	secondStageTotalPoints: number;
	secondBStageQualified: boolean;
	secondBOralDescription: string;

	thirdAStageTopic: string;
	thirdAStagePoints: number;
	thirdAStageQualified: boolean;
	thirdAJuryPairId: number | null;
	thirdAJuryPairName: string;
	thirdAWorkStatus: string | null;
	thirdADriveCopiedAt: string | null;
	thirdAAutoAccessDisabled: boolean;
	thirdAAccessVerified: boolean;

	thirdBOneStagePoints: number;
	thirdBTwoStagePoints: number;
	thirdBStageTotalPoints: number;
	finalTitle: string;

	constructor(
		id: number | undefined,
		firstStageStatus: string,
		firstStagePoints: number,
		firstStageQualified: boolean,
		secondAStageTopic: string,
		secondAOneStagePoints: number,
		secondATwoStagePoints: number,
		secondAStageQualified: boolean,
		secondBOneStagePoints: number,
		secondBTwoStagePoints: number,
		secondBThreeStagePoints: number,
		secondStageTotalPoints: number,
		secondBStageQualified: boolean,
		secondBOralDescription: string,
		thirdAStageTopic: string,
		thirdAStagePoints: number,
		thirdAStageQualified: boolean,
		thirdAJuryPairId: number | null,
		thirdAJuryPairName: string,
		thirdAWorkStatus: string | null,
		thirdADriveCopiedAt: string | null,
		thirdAAutoAccessDisabled: boolean,
		thirdAAccessVerified: boolean,
		thirdBOneStagePoints: number,
		thirdBTwoStagePoints: number,
		thirdBStageTotalPoints: number,
		finalTitle: string,
	) {
		this.id = id;
		this.firstStageStatus = firstStageStatus;
		this.firstStagePoints = firstStagePoints;
		this.firstStageQualified = firstStageQualified;
		this.secondAStageTopic = secondAStageTopic;
		this.secondAOneStagePoints = secondAOneStagePoints;
		this.secondATwoStagePoints = secondATwoStagePoints;
		this.secondAStageQualified = secondAStageQualified;
		this.secondBOneStagePoints = secondBOneStagePoints;
		this.secondBTwoStagePoints = secondBTwoStagePoints;
		this.secondBThreeStagePoints = secondBThreeStagePoints;
		this.secondStageTotalPoints = secondStageTotalPoints;
		this.secondBStageQualified = secondBStageQualified;
		this.secondBOralDescription = secondBOralDescription;
		this.thirdAStageTopic = thirdAStageTopic;
		this.thirdAStagePoints = thirdAStagePoints;
		this.thirdAStageQualified = thirdAStageQualified;
		this.thirdAJuryPairId = thirdAJuryPairId;
		this.thirdAJuryPairName = thirdAJuryPairName;
		this.thirdAWorkStatus = thirdAWorkStatus;
		this.thirdADriveCopiedAt = thirdADriveCopiedAt;
		this.thirdAAutoAccessDisabled = thirdAAutoAccessDisabled;
		this.thirdAAccessVerified = thirdAAccessVerified;
		this.thirdBOneStagePoints = thirdBOneStagePoints;
		this.thirdBTwoStagePoints = thirdBTwoStagePoints;
		this.thirdBStageTotalPoints = thirdBStageTotalPoints;
		this.finalTitle = finalTitle;
	}

	public static fromApiResponse(data: any) {
		return new Result(
			data.id ? data.id : undefined,
			data.first_stage_status ? data.first_stage_status : '',
			data.first_stage_points ? data.first_stage_points : 0,
			data.first_stage_qualified ? data.first_stage_qualified : false,
			data.second_a_stage_topic ? data.second_a_stage_topic : '',
			data.second_a_one_stage_points ? data.second_a_one_stage_points : 0,
			data.second_a_two_stage_points ? data.second_a_two_stage_points : 0,
			data.second_a_stage_qualified ? data.second_a_stage_qualified : false,
			data.second_b_one_stage_points ? data.second_b_one_stage_points : 0,
			data.second_b_two_stage_points ? data.second_b_two_stage_points : 0,
			data.second_b_three_stage_points ? data.second_b_three_stage_points : 0,
			data.second_stage_total_points ? data.second_stage_total_points : 0,
			data.second_b_stage_qualified ? data.second_b_stage_qualified : false,
			data.second_b_oral_description ? data.second_b_oral_description : '',
			data.third_a_stage_topic ? data.third_a_stage_topic : '',
			data.third_a_stage_points ? data.third_a_stage_points : 0,
			data.third_a_stage_qualified ? data.third_a_stage_qualified : 0,
			data.third_a_jury_pair_id ? Number(data.third_a_jury_pair_id) : null,
			data.jury_pair?.name ? String(data.jury_pair.name) : '',
			data.third_a_work_status ? String(data.third_a_work_status) : null,
			data.third_a_drive_copied_at ? String(data.third_a_drive_copied_at) : null,
			Boolean(data.third_a_auto_access_disabled),
			Boolean(data.third_a_access_verified),
			data.third_b_one_stage_points ? data.third_b_one_stage_points : 0,
			data.third_b_two_stage_points ? data.third_b_two_stage_points : 0,
			data.third_b_total_stage_points ? data.third_b_total_stage_points : 0,
			data.final_title ? data.final_title : '',
		);
	}
}

export default Result;
